import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import * as infoHealth from './infoHealth';

window.APP_VERSION =
  process.env.NODE_ENV === 'production' ? process.env.REACT_APP_VERSION : 'dev';
window.APP_SERVER =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_SERVER
    : 'local';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

infoHealth.start();
